export default __webpack_public_path__ + "static/media/Group11630.bd060d0f.svg";